import { render, staticRenderFns } from "./YourPromotion.vue?vue&type=template&id=61f1e0c4&lang=pug&"
import script from "./YourPromotion.vue?vue&type=script&lang=js&"
export * from "./YourPromotion.vue?vue&type=script&lang=js&"
import style0 from "./YourPromotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports